/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import icon_mail from "../../assets/icons/icon-mail.svg";
import icon_mail__active from "../../assets/icons/icon-mail--active.svg";
import icon_whatsapp from "../../assets/icons/icon-whatsapp.svg";
import icon_whatsapp__active from "../../assets/icons/icon-whatsapp--active.svg";
import icon_facebook from "../../assets/icons/icon-facebook.svg";
import icon_facebook__active from "../../assets/icons/icon-facebook--active.svg";
import icon_user from "../../assets/icons/icon-user.svg";
import image_banner from "../../assets/images/banner--2.jpg";
import { useInvitationContext } from "../../context/providers/InvitationContext";
import { showErrorMessage } from "../../utils/notification";
import ShareLink from "react-facebook-share-link";
const SocialTabs = ({ user, code }) => {
	const [tabIndex, setTabIndex] = React.useState(0);
	const { sendInvitation } = useInvitationContext();
	const [friend, setFriend] = React.useState({
		name: "",
		email: "",
	});
	const { name, email } = friend;
	const handleOnChange = (e) => setFriend({ ...friend, [e.target.name]: e.target.value });
	const handleEmailFormSubmit = (e) => {
		e.preventDefault();
		if (user.email === email) {
			showErrorMessage(`You can't send invitation to yourself`);
		} else {
			const data = {
				user: user._id,
				name: friend.name,
				email: friend.email,
				firstName: user.firstName,
				lastName: user.lastName,
				code: code,
			};
			//console.log(friend);
			sendInvitation(data);
			setFriend({
				name: "",
				email: "",
			});
		}
	};

	const sendWhatsappInvitation = () => {
		const message = `Kodjo Hounnake vous invite à apprendre l'anglais sur KodjoAcademy en vous faisant bénéficier d'un coupon de réduction de 20 % sur votre prochain cours. Cliquez sur le lien suivant => ${process.env.REACT_APP_ACADEMY_SERVER}/cc/${code}`;
		const link = "https://api.whatsapp.com/send?text=" + message;
		window.open(encodeURI(link));
	};
	return (
		<Tabs
			className="mt-4"
			selectedIndex={tabIndex}
			onSelect={(index) => {
				setTabIndex(index);
			}}
		>
			<TabList className="d-flex">
				<Tab className="w-100">
					{tabIndex === 0 ? (
						<button className="btn btn--primary w-100">
							<img src={icon_mail__active} alt="" className="mr-md-1" />
							<span className="pl-2 d-none d-md-block">Email</span>
						</button>
					) : (
						<button className="btn btn--white w-100">
							<img src={icon_mail} alt="" className="mr-md-1" />
							<span className="pl-2 d-none d-md-block">Email</span>
						</button>
					)}
				</Tab>
				<Tab className="w-100 ml-2">
					{tabIndex === 1 ? (
						<button className="btn btn--whatsapp w-100">
							<img src={icon_whatsapp__active} alt="" className="mr-md-1" />
							<span className="pl-2 d-none d-md-block">WhatsApp</span>
						</button>
					) : (
						<button className="btn btn--white w-100">
							<img src={icon_whatsapp} alt="" className="mr-md-1" />
							<span className="pl-2 d-none d-md-block">WhatsApp</span>
						</button>
					)}
				</Tab>
				<Tab className="w-100 ml-2">
					{tabIndex === 2 ? (
						<button className="btn btn--facebook w-100">
							<img src={icon_facebook__active} alt="" className="mr-md-1" />
							<span className="pl-2 d-none d-md-block">Facebook</span>
						</button>
					) : (
						<button className="btn btn--white w-100">
							<img src={icon_facebook} alt="" className="mr-md-1" />
							<span className="pl-2 d-none d-md-block">Facebook</span>
						</button>
					)}
				</Tab>
			</TabList>

			<TabPanel>
				<div className="pt-4">
					<form onSubmit={handleEmailFormSubmit}>
						<div className="d-md-flex">
							<div className="input__field w-100">
								<div className="input__group">
									<input
										type="text"
										className="input input--primary input--with_icon"
										placeholder="Your friend's name"
										value={name}
										name="name"
										onChange={handleOnChange}
										required
										minLength={6}
									/>
									<img src={icon_user} alt="" className="input__icon" />
								</div>
							</div>
							<div className="input__field mt-3 mt-md-auto ml-md-3 w-100">
								<div className="input__group">
									<input
										type="mail"
										className="input input--primary input--with_icon"
										placeholder="Email"
										required
										name="email"
										value={email}
										onChange={handleOnChange}
									/>
									<img src={icon_mail} alt="" className="input__icon" />
								</div>
							</div>
						</div>
						<div className="input__field mt-3">
							<textarea
								name=""
								className="input input--primary"
								defaultValue="Kodjo Hounnake  vous invite à apprendre l'anglais sur KodjoAcademy en vous faisant bénéficier d'un coupon de réduction de 20 %  sur votre prochain cours."
								disabled
							></textarea>
						</div>
						<div className="input__field mt-3 d-flex justify-content-center">
							<button type="submit" className="btn btn--primary w-100">
								Share
							</button>
						</div>
					</form>
				</div>
			</TabPanel>
			<TabPanel>
				<div className="pt-4">
					<div className="input__field">
						<textarea
							name=""
							className="input input--primary"
							defaultValue={`Kodjo Hounnake vous invite à apprendre l'anglais sur KodjoAcademy en vous faisant bénéficier d'un coupon de réduction de 20 % sur votre prochain cours. Cliquez sur le lien suivant => ${process.env.REACT_APP_ACADEMY_SERVER}/cc/${code}`}
							disabled
						></textarea>
					</div>
					<div className="input__field mt-3 d-flex justify-content-center">
						<button type="button" className="btn btn--whatsapp w-100" onClick={sendWhatsappInvitation}>
							Share on WhatsApp
						</button>
					</div>
				</div>
			</TabPanel>
			<TabPanel>
				<div className="pt-4">
					<div className="d-md-flex">
						<div className="input__field radius--default">
							<img src={image_banner} alt="" className="d-block invite__banner" />
						</div>
						<div className="input__field mt-3 mt-md-auto w-100 ml-md-4">
							<textarea
								name=""
								className="input input--primary"
								defaultValue={`Kodjo Hounnake vous invite à apprendre l'anglais sur KodjoAcademy en vous faisant bénéficier d'un coupon de réduction de 20 % sur votre prochain cours. Cliquez sur le lien suivant => ${process.env.REACT_APP_ACADEMY_SERVER}/cc/${code}`}
								disabled
							></textarea>
						</div>
					</div>
					<div className="input__field mt-3 d-flex justify-content-center">
						<ShareLink link={`${process.env.REACT_APP_ACADEMY_SERVER}/cc/${code}`}>
							{(link) => (
								<a href={link} target="_blank" className="btn btn--facebook w-100" rel="noopener noreferrer">
									Share on Facebook
								</a>
							)}
						</ShareLink>
					</div>
				</div>
			</TabPanel>
		</Tabs>
	);
};

export default SocialTabs;
